"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const Settings_1 = __importDefault(require("configs/Settings"));
const legacyRedirect_1 = require("modules/app/services/datahub/legacyRedirect");
const CenterHelpLink = ({ children, className, shortLocale }) => {
    const handleClick = () => {
        legacyRedirect_1.DatahubLegacyRedirectService.frequentlyAskedQuestionEvent();
    };
    const getRedirectHelpCenterUrl = () => {
        let locale = 'en';
        if (shortLocale === 'pt') {
            locale = 'pt-BR';
        }
        else if (shortLocale === 'es') {
            locale = 'es';
        }
        return `${Settings_1.default.app.helpCenter}/${locale}/article/entenda-sobre-o-redirecionamento-do-hotmart-club/16064195628941?itm_medium=internal&itm_source=platform&itm_campaign=br_traffic_club_popup_redirect-consumo-creator`;
    };
    return ((0, jsx_runtime_1.jsx)("a", { href: getRedirectHelpCenterUrl(), target: "_blank", rel: "noopener noreferrer", className: className, onClick: handleClick, children: children }));
};
exports.default = CenterHelpLink;
